import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { formDevtoolsPlugin } from "@tanstack/react-form-devtools";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { APIProvider, useApiIsLoaded } from "@vis.gl/react-google-maps";
import { ToastContainer } from "react-toastify";
import { theme } from "../theme";
import UserContextProvider from "./contexts/UserContext/index.provider";
import { QueryClientProvider } from "./libs/QueryClientProvider";
import AppRoutes from "./routes";
import { pickerLocale } from "./utils/picker-date";

const googleMapsApiKey = import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY;

function Inner() {
  const isLoaded = useApiIsLoaded();

  return (
    <div className="App">
      <UserContextProvider>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pickerLocale}>
            {isLoaded ? <AppRoutes /> : <div>Loading...</div>}
          </LocalizationProvider>
        </ThemeProvider>
      </UserContextProvider>
    </div>
  );
}

const App: React.FunctionComponent = () => {
  return (
    <APIProvider apiKey={googleMapsApiKey} libraries={["places"]}>
      <QueryClientProvider>
        <Inner />
        {import.meta.env.MODE === "development" && (
          <>
            <TanStackDevtools
              plugins={[{ ...formDevtoolsPlugin() }]}
              config={{ defaultOpen: false }}
              eventBusConfig={{ debug: false }}
            />
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          </>
        )}
        <ToastContainer />
      </QueryClientProvider>
    </APIProvider>
  );
};

export default App;
